//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'PRAM',
  data() {
    return {
      defaultJson:{
        "Suprasternal Indrawing": "锁骨上窝凹陷",
        "Severe": "重度",
        "Moderate": "中度",
        "audible without stethoscope \/ silent chest with minimal air entry": "不用听诊器即可闻及 \/ 寂静胸（极少量的通气）",
        "O₂ Saturation": "O₂ 饱和度",
        "insp. and exp.": "吸气相和呼气相",
        "inspiratory and expiratory": "吸气相和呼气相",
        "decreased at bases": "肺底部减弱",
        "normal": "正常",
        "widespread decreased": "广泛性减弱",
        "expiratory only": "仅呼气相",
        "absent \/ minimal": "无 \/ 极少",
        "Air Entry": "呼吸音",
        "expiratory": "呼气相",
        "Mild": "轻度",
        "Scalene Retractions": "斜角肌收缩",
        "Wheezing": "哮鸣音",
        "extreme or silent": "极重或寂静胸",
        "absent": "无"
      },
      form:{
        sao2:'',
        wheezing:'',
        airentry:'',
        suprasternalindrawing:'0',
        scaleneretractions:'0'
      },
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"2",name:'≤ 89 %'},
        {value:"1",name:'90-93 %'},
        {value:"0",name:'≥ 94 %'},
      ],
      dataList2:[
        {value:"0",name:'无'},
        {value:"1",name:'仅呼气相',shortName:'呼气相'},
        {value:"2",name:'吸气相和呼气相',shortName:'吸气相和呼气相'},
        {value:"3",name:'不用听诊器即可闻及 / 寂静胸（极少量的通气）',shortName:'极重或寂静胸'},
      ],
      dataList3:[
        {value:"0",name:'正常'},
        {value:"1",name:'肺底部减弱',shortName:'肺底部减弱'},
        {value:"2",name:'广泛性减弱',shortName:'广泛性减弱'},
        {value:"3",name:'无 / 极少',shortName:'无 / 极少'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // 	(suprasternalindrawing * 2) + (scaleneretractions * 2) + sao2 + wheezing + airentry
        let result = (form.suprasternalindrawing * 2) + (form.scaleneretractions * 2) + form.sao2 + form.wheezing + form.airentry
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/PRAM.vue